import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective } from 'mbs-ui-kit';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';
import { SmartSearchAgentTemplateComponent } from '../base-template/smart-search-agent-template.component';

@Component({
  selector: 'mbs-smart-search-product-installed-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchProductInstalledTemplateComponent) }],
  imports: [CommonModule]
})
export class SmartSearchProductInstalledTemplateComponent extends SmartSearchAgentTemplateComponent {
  i18nPipe: I18NextPipe;

  constructor() {
    const i18nPipe = inject(I18NextPipe);
    const ability = inject(AbilityService);

    super();

    this.i18nPipe = i18nPipe;
  }
  public tag = SmartSearchTemplateName.ProductInstalled;
}
